export default {
  login: {
    loginType: '密码登录'
  }
};
